<template>
	<div>
		<button @click="forcePlay()">PLAY</button>
		<div id='lottiecontainer'></div>
		<div class="debugger"></div>
	</div>
</template>

<script>
/* eslint-disable no-param-reassign */
/* global lottie */
// import lottie from 'lottie-web';
import $ from 'jquery';
import defaultLottie from '@/assets/defaultLottie.json';

export default {
	data() {
		return {

		};
	},
	mounted() {
		this.forcePlay();
	},
	methods: {
		forcePlay() {
			const container = document.getElementById('lottiecontainer');
			const animationData = defaultLottie;
			// const changeValue = true; // switch
			const queryHeading1 = this.$route.query.heading1;
			const queryHeading2 = this.$route.query.heading2;
			const queryColor1 = this.$route.query.color1;
			const queryColor2 = this.$route.query.color2;
			const queryHeadingColor1 = this.$route.query.colorheading1;
			const queryHeadingColor2 = this.$route.query.colorheading2;
			const headingtext1 = queryHeading1 || 'TREVØR NØÅH';
			const headingtext2 = queryHeading2 || 'DÆILY SHOW HOST';
			const headingtext1color = queryColor1 || '#e31282';
			const headingtext2color = queryColor2 || '#1c13f2';
			const element1color = queryHeadingColor1 || '#f5b00f';
			const element2color = queryHeadingColor2 || '#27cc9a';
			animationData.layers.forEach((obj) => {
				if (obj.nm === 'ELEMENT1') {
					obj.shapes[0].it[2].c.k[0] = this.hexjsoncolor(element1color).r;
					obj.shapes[0].it[2].c.k[1] = this.hexjsoncolor(element1color).g;
					obj.shapes[0].it[2].c.k[2] = this.hexjsoncolor(element1color).b;
				}

				if (obj.nm === 'ELEMENT2') {
					obj.shapes[0].it[2].c.k[0] = this.hexjsoncolor(element2color).r;
					obj.shapes[0].it[2].c.k[1] = this.hexjsoncolor(element2color).g;
					obj.shapes[0].it[2].c.k[2] = this.hexjsoncolor(element2color).b;
				}

				if (obj.nm === 'H1TEXT') {
					obj.t.d.k[0].s.t = headingtext1;
					obj.t.d.k[0].s.fc[0] = this.hexjsoncolor(headingtext1color).r;
					obj.t.d.k[0].s.fc[1] = this.hexjsoncolor(headingtext1color).g;
					obj.t.d.k[0].s.fc[2] = this.hexjsoncolor(headingtext1color).b;
				}

				if (obj.nm === 'H2TEXT') {
					obj.t.d.k[0].s.t = headingtext2;
					obj.t.d.k[0].s.fc[0] = this.hexjsoncolor(headingtext2color).r;
					obj.t.d.k[0].s.fc[1] = this.hexjsoncolor(headingtext2color).g;
					obj.t.d.k[0].s.fc[2] = this.hexjsoncolor(headingtext2color).b;
				}
			});

			const animcomp = {
				name: 'lottiescene',
				container,
				renderer: 'svg',
				animationData,
				loop: this.content.loop,
				prerender: true,
				autoplay: true,
				useframes: true,
			};
			lottie.loadAnimation(animcomp);
			lottie.play();
		},
		hexjsoncolor(hex) {
			const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
			return result ? {
				r: Math.round(parseInt(result[1], 16) / 255 * 1000000000000) / 1000000000000,
				g: Math.round(parseInt(result[2], 16) / 255 * 1000000000000) / 1000000000000,
				b: Math.round(parseInt(result[3], 16) / 255 * 1000000000000) / 1000000000000,
			} : null;
		},
		dd(label, value, append) {
			if (append) {
				$('.debugger').append(`<br>${label} : ${value}`);
			} else {
				$('.debugger').html(`${label} : ${value}`);
			}
		},
		playResumeAnimation() { // animation OUT playback
			this.animax.play();
		},

	},
	computed: {

	},
	watch: {

	},
};
</script>
